/**
 * Wire mappers for asado (FP-1449/FP-1545, ADR-2).
 *
 * A mapper belongs here only when the public SDK params and the wire shape genuinely differ.
 * Where the two are already the same shape (e.g. `getSaleProducts`' body), the params pass
 * straight to `createRequest` and its `Input` generic carries the derived type directly.
 */
import type {
  GetCustomizeAccessV2Params,
  GetCustomizeAccessV2Query,
  GetLiveSalesQuery,
} from './types';

/**
 * `GET /bff/v1/sales/live` documents `preview` as a wire `string` -- the querystring schema is
 * `z.stringbool()`, which coerces server-side -- so the SDK keeps the ergonomic `boolean` param
 * and this mapper serializes it.
 */
export const toGetLiveSalesQuery = (preview: boolean | undefined): GetLiveSalesQuery | undefined =>
  preview === undefined ? undefined : { preview: String(preview) };

/**
 * `GET /bff/v2/customize/access` documents `preview` as the same wire `string`
 * (`z.stringbool()`) as `getBffV1SalesLive` above. v1's `getCustomizeAccess` never exposed
 * `preview` so it never needed this; v2 does (WEB-6220, decision D9).
 */
export const toGetCustomizeAccessV2Query = ({
  preview,
  ...rest
}: GetCustomizeAccessV2Params): GetCustomizeAccessV2Query => ({
  ...rest,
  ...(preview !== undefined && { preview: String(preview) }),
});
